"use strict";(function(){HTMLElement.prototype.matchHeight=function(settings){return new MatchHeight(this,settings)};function MatchHeight(wrapEl,settings){this.wrapEl=wrapEl;let default_settings={elements:null,byRow:true,target:null,attributeName:null,attributeValue:null,property:"height",remove:null,events:true,throttle:80};this.settings=Object.assign(Object.assign({},default_settings),settings);if(!this._validateProperty(this.settings.property)){this.settings.property="height"}if(this.settings.events){var $this=this;this._bind=function(){$this._applyAll($this)};if(document.readyState!=="loading"){this._bind()}else{document.addEventListener("DOMContentLoaded",this._bind,{once:true})}if(this.settings.throttle&&this.settings.throttle>0)this._bind=this._throttle(this._bind,this.settings.throttle);this._init()}}MatchHeight.prototype._init=function(){window.addEventListener("resize",this._bind);window.addEventListener("orientationchange",this._bind)};MatchHeight.prototype._unbind=function(){window.removeEventListener("resize",this._bind);window.removeEventListener("orientationchange",this._bind)};MatchHeight.prototype._merge=function(o1,o2){if(o1!=null){for(var i in o1){o2[i]=o1[i]}}return o2};MatchHeight.prototype._throttle=function(fn,threshold){let last,deferTimer;return function(){const now=Date.now();if(last&&now<last+threshold){clearTimeout(deferTimer);deferTimer=setTimeout(function(){last=now;fn()},threshold)}else{last=now;fn()}}};MatchHeight.prototype._applyAll=function($this){if($this==null){$this=this}$this._apply();if($this.settings.attributeName&&$this._validateProperty($this.settings.attributeName)){$this._applyDataApi($this.settings.attributeName)}$this._applyDataApi("data-match-height");$this._applyDataApi("data-mh")};MatchHeight.prototype._validateProperty=function(value){return String(value).toLowerCase().match(/^([a-z-]{2,})$/)};MatchHeight.prototype._parse=function(value){return parseFloat(value)||0};MatchHeight.prototype._rows=function(elements){var $this=this;var tolerance=1,lastTop=-1,listRows=[],rows=[];elements.forEach($that=>{var top=$that.getBoundingClientRect().top-$this._parse(window.getComputedStyle($that).getPropertyValue("margin-top"));if(lastTop!=-1&&Math.floor(Math.abs(lastTop-top))>=tolerance){listRows.push(rows);rows=[];lastTop=-1}rows.push($that);lastTop=top});listRows.push(rows);return listRows};MatchHeight.prototype._applyDataApi=function(property){var $this=this;var $row=Array.from(this.wrapEl.querySelectorAll("["+property+"]"));$row.forEach($el=>{var groupId=$el.getAttribute(property);$this.settings=$this._merge({attributeName:property,attributeValue:groupId},$this.settings);$this._apply()})};MatchHeight.prototype._remove=function(){var $elements=[];var opts=this.settings;if(opts.elements){$elements=Array.from(this.wrapEl.querySelectorAll(opts.elements))}else{if(opts.attributeName&&opts.attributeValue){$elements=Array.from(this.wrapEl.querySelectorAll("["+opts.attributeName+'="'+opts.attributeValue+'"]'))}}$elements.forEach(item=>{item.style.setProperty(opts.property,"");if(item.getAttribute("style")==="")item.removeAttribute("style")})};MatchHeight.prototype._apply=function(){var $this=this;var opts=$this.settings;var $elements=[];if(opts.elements&&opts.elements.trim()!=""){$elements=Array.from(this.wrapEl.querySelectorAll(opts.elements))}else{if(opts.attributeName&&$this._validateProperty(opts.attributeName)&&opts.attributeValue&&opts.attributeValue.trim()!=""){$elements=Array.from(this.wrapEl.querySelectorAll("["+opts.attributeName+'="'+opts.attributeValue+'"]'))}}var rows=[$elements];if(opts.byRow&&!opts.target){$elements.forEach($that=>{var display=window.getComputedStyle($that).getPropertyValue("display");if(display&&(display!=="inline-block"&&display!=="flex"&&display!=="inline-flex")){display="display: block; "}$that.setAttribute("style-cache",$that.getAttribute("style")||"");$that.setAttribute("style",display+"padding-top: 0; padding-bottom: 0; margin-top: 0; margin-bottom: 0; border-top-width: 0; border-bottom-width: 0; height: 100px; overflow: hidden;")});rows=this._rows($elements);$elements.forEach($that=>{$that.setAttribute("style",$that.getAttribute("style-cache")||"");$that.removeAttribute("style-cache");if($that.getAttribute("style")==="")$that.removeAttribute("style")})}rows.forEach($row=>{var targetHeight=0;if(!opts.target){if(opts.byRow&&$row.length<=1){$row.forEach($that=>{$this._resetStyle($that,opts.property)});return}$row.forEach($that=>{var style=$that.getAttribute("style")||"",display=window.getComputedStyle($that).getPropertyValue("display");if(display&&(display!=="inline-block"&&display!=="flex"&&display!=="inline-flex")){display="block"}$that.setAttribute("style","display: "+display+";");var isTarget=true;if(opts.remove){if(opts.remove instanceof NodeList){opts.remove.forEach($el=>{if($that===$el){isTarget=false}})}else{if($that===opts.remove){isTarget=false}}}if(isTarget){if($that.getBoundingClientRect().height>targetHeight){targetHeight=$that.getBoundingClientRect().height}}if(style){$that.setAttribute("style",style)}else{$that.style.setProperty("display","")}if($that.getAttribute("style")==="")$that.removeAttribute("style")})}else{targetHeight=opts.target.getBoundingClientRect().height}$row.forEach($that=>{var verticalPadding=0;if(opts.target&&$that===opts.target){return}verticalPadding=$this._parse(window.getComputedStyle($that).getPropertyValue("padding-top"))+$this._parse(window.getComputedStyle($that).getPropertyValue("padding-bottom"))+$this._parse(window.getComputedStyle($that).getPropertyValue("border-top-width"))+$this._parse(window.getComputedStyle($that).getPropertyValue("border-bottom-width"));$that.style.setProperty(opts.property,targetHeight-verticalPadding+"px");if($that.getBoundingClientRect().height<targetHeight){$that.style.setProperty(opts.property,targetHeight+"px")}if(opts.remove){if(opts.remove instanceof NodeList){var removedItems=Array.from(opts.remove);removedItems.forEach($el=>{if($that===$el){$this._resetStyle($el,opts.property)}})}else{if($that===opts.remove){$this._resetStyle($that,opts.property)}}}})})};MatchHeight.prototype._resetStyle=function($that,property){if(this._validateProperty(property)){$that.style.setProperty(property,"");if($that.getAttribute("style")==="")$that.removeAttribute("style")}}})();


document.addEventListener('DOMContentLoaded', function() {

  // TAB
  var tabLinks = document.querySelectorAll('.tab-a');
  tabLinks.forEach(function(link) {
    link.addEventListener('click', function() {
      var dataId = this.getAttribute('data-id');
      
      document.querySelectorAll('.tab').forEach(function(tab) {
          tab.classList.remove('tab-active');
      });
      
      document.querySelector(".tab[data-id='" + dataId + "']").classList.add('tab-active');
      
      tabLinks.forEach(function(link) {
          link.classList.remove('active-a');
      });
      
      this.classList.add('active-a');
    });
  });

  //header JS
  var announce_country = document.querySelector('.announcement-bar .disclosure-form button.disclosure__toggle--currency');
  var announce_list = document.querySelector('.announcement-bar .disclosure-form ul.disclosure-list');
  if(announce_country){
    announce_country.addEventListener('click', function() {
      const ariaExpanded = announce_country.getAttribute("aria-expanded") === "true";

      if (ariaExpanded) {
        // hideList();
        announce_country.setAttribute("aria-expanded", false);
        announce_list.setAttribute("aria-hidden", true);
      } else {
        // showList();
        announce_country.setAttribute("aria-expanded", true);
        announce_list.setAttribute("aria-hidden", false);
        announce_list.classList.add('disclosure-list--right');
      }
    });
  }


  document.addEventListener("click", handleBodyClick);

  function handleBodyClick(evt) {
    const toggle = document.querySelector('.announcement-bar .disclosure-form button.disclosure__toggle--currency'); // Assuming the element with aria-expanded is the toggle
    const ariaExpanded = toggle.getAttribute("aria-expanded") === "true"; // Check if the dropdown is open
    var announce_list = document.querySelector('.announcement-bar .disclosure-form ul.disclosure-list');
    
    // Check if the click is within the dropdown or its toggle
    const isOption = toggle.contains(evt.target) || announce_list.contains(evt.target); 
    
    if (ariaExpanded && !isOption) { // If the dropdown is open and the click is outside
      // hideList(); // Close the dropdown
      announce_country.setAttribute("aria-expanded", false);
          announce_list.setAttribute("aria-hidden", true);
    }
  }

  // $('.product-item .product-item__variant-info ul li img').on('click',function(){
  //   var var_img_url = $(this).attr('data-var-url');
  //   if(var_img_url){
  //     console.log('has_img',var_img_url);
  //   }
  //   // var image_url = $(this).parents('.product-item').find('.product-item__media .product-item__image--one')
  // });
    document.querySelectorAll('.product-item .product-item__variant-info ul li').forEach(function(img) {
        img.addEventListener('click', function() {
            var var_img_url = this.getAttribute('data-var-url');
            if (var_img_url) {
                // Find the closest .product-item element
                var productItem = this.closest('.product-item');
              
                if (productItem) {
                      productItem.querySelectorAll('.product-item__variant-info ul li').forEach(function(item) {
                        item.classList.remove('active');
                      });
                      img.classList.add('active');
                    // Find the .product-item__image--one element inside the .product-item
                    var imageElement = productItem.querySelector('.product-item__media .product-item__image--one img');
                    var imageElement_2 = productItem.querySelector('.product-item__media .product-item__image--two');
                    if (imageElement) {
                        imageElement.removeAttribute('srcset');
                        imageElement.setAttribute('src', var_img_url);
                    }
                    if(imageElement_2){
                      imageElement_2.classList.remove('active');
                    }
                }
            }
        });
    });


    /*-- Match Height --*/
    /*
    setTimeout(function(){
      document.body.matchHeight({elements: '.product-item__product-title'});
    },1000);
    */
  
    //open countries hide header drawer button
    document.querySelectorAll('a.drawer-menu__link[data-item="viewCurrency"]').forEach(function(element) {
      element.addEventListener('click', function() {
        document.querySelector('button.header__icon-menu').classList.add('hide');
      });
    });

    //close countries show header button
    document.querySelectorAll('.drawer-menu__list--country-selector .drawer-menu__item--heading-back-link').forEach(function(element) {
      element.addEventListener('click', function() {
        console.log('hiii');
        document.querySelector('button.header__icon-menu').classList.remove('hide');
      });
    });



     /*-- Complete the look Section --*/
      document.querySelectorAll('.modify-complete-the-look-section .product-custom-swatch .swatch_option .product__color-swatches button.product__color-swatch').forEach(function(button) {
        button.addEventListener('click', function() {
          // console.log('yes clicked');
        
          // Remove 'selected' class from sibling buttons
          this.parentElement.querySelectorAll('button.product__color-swatch').forEach(function(sibling) {
            sibling.classList.remove('selected');
          });
        
          // Add 'selected' class to the clicked button
          this.classList.add('selected');
          let value = this.getAttribute('data-option-value');
          if(value){
            this.closest('.swatch_option').querySelector('.product__label-wrapper [data-selected-value-for-option]').textContent = value ;
          }
        
          let selectedOptions = {
            option1: null,
            option2: null,
            option3: null
          };
        
          let modifySection = this.closest('.modify-complete-product');

          //for swatches option
          modifySection.querySelectorAll('.product-custom-swatch .swatch_option').forEach(function(swatchOption) {
            let selectedButton = swatchOption.querySelector('.product__color-swatches button.product__color-swatch.selected');
            let value = selectedButton ? selectedButton.getAttribute('data-option-value') : null;
            let op_id = swatchOption.querySelector('.product__color-swatches--inner select')?.id;
      
            if (op_id === 'option1') {
              selectedOptions.option1 = value;
            } else if (op_id === 'option2') {
              selectedOptions.option2 = value;
            } else if (op_id === 'option3') {
              selectedOptions.option3 = value;
            }
          });

          //for dropdown option
          modifySection.querySelectorAll('.product-custom-option .product__option').forEach(function(customOption) {
            let selectElement = customOption.querySelector('select');
            let value = selectElement ? selectElement.value : null;
            let op_id = selectElement ? selectElement.id : null;
      
            if (op_id === 'option1') {
              selectedOptions.option1 = value;
            } else if (op_id === 'option2') {
              selectedOptions.option2 = value;
            } else if (op_id === 'option3') {
              selectedOptions.option3 = value;
            }
          });


             // Select the script element
            const variantScript = modifySection.querySelector('script[data-variant-json]');
  
            // console.log(selectedOptions);
            if (variantScript) {
                const variantData = JSON.parse(variantScript.textContent);
                    // Find matching variant
                  const matchingVariant = variantData.find(variant =>
                    variant.option1 === selectedOptions.option1 &&
                    variant.option2 === selectedOptions.option2 &&
                    variant.option3 === selectedOptions.option3
                  );
              
                  if (matchingVariant) {
                    // console.log('Matching Variant ID:', matchingVariant.id);
                    modifySection.querySelector('.product-add-to-cart a').setAttribute('data-id',matchingVariant.id);
                    // console.log(matchingVariant.featured_image.src);
                    if(matchingVariant.available){
                      modifySection.querySelector('.product-add-to-cart a').removeAttribute('disabled');
                      modifySection.querySelector('.product-add-to-cart a').classList.remove('disabled');
                      var avail_label = modifySection.querySelector('.product-add-to-cart a').getAttribute('data-avail-label');
                      modifySection.querySelector('.product-add-to-cart a').textContent = avail_label;
                    }else{
                      modifySection.querySelector('.product-add-to-cart a').removeAttribute('disabled');
                      modifySection.querySelector('.product-add-to-cart a').classList.remove('disabled');
                      var sold_label = modifySection.querySelector('.product-add-to-cart a').getAttribute('data-sold-label');
                      modifySection.querySelector('.product-add-to-cart a').textContent = sold_label;
                    }
                    
                    if(matchingVariant.featured_image.src){
                      var image_tag = modifySection.querySelector('.product-image img');
                      image_tag.setAttribute('src',matchingVariant.featured_image.src);
                    }

                  // } 
                   }
          }

        });
      });


      //on select dropdown change
      document.querySelectorAll('.modify-complete-the-look-section .product-custom-option').forEach(function(option) {
        option.querySelectorAll('select').forEach(function(select) {
          select.addEventListener('change', function() {
            // console.log('hiii');

          let value = this.value;
          if(value){
            this.closest('.product__option').querySelector('.product__label-wrapper [data-selected-value-for-option]').textContent = value ;
          }

              let selectedOptions = {
                option1: null,
                option2: null,
                option3: null
              };
            
              let modifySection = this.closest('.modify-complete-product');
            
            //for swatches option
              modifySection.querySelectorAll('.product-custom-swatch .swatch_option').forEach(function(swatchOption) {
                let selectedButton = swatchOption.querySelector('.product__color-swatches button.product__color-swatch.selected');
                let value = selectedButton ? selectedButton.getAttribute('data-option-value') : null;
                let op_id = swatchOption.querySelector('.product__color-swatches--inner select')?.id;
          
                if (op_id === 'option1') {
                  selectedOptions.option1 = value;
                } else if (op_id === 'option2') {
                  selectedOptions.option2 = value;
                } else if (op_id === 'option3') {
                  selectedOptions.option3 = value;
                }
              });

            //for dropdown option
              modifySection.querySelectorAll('.product-custom-option .product__option').forEach(function(customOption) {
                let selectElement = customOption.querySelector('select');
                let value = selectElement ? selectElement.value : null;
                let op_id = selectElement ? selectElement.id : null;
          
                if (op_id === 'option1') {
                  selectedOptions.option1 = value;
                } else if (op_id === 'option2') {
                  selectedOptions.option2 = value;
                } else if (op_id === 'option3') {
                  selectedOptions.option3 = value;
                }
              });


            // Select the script element
            const variantScript = modifySection.querySelector('script[data-variant-json]');
  
            // console.log(selectedOptions);
           
            if (variantScript) {
                const variantData = JSON.parse(variantScript.textContent);
                    // Find matching variant
                  const matchingVariant = variantData.find(variant =>
                    variant.option1 === selectedOptions.option1 &&
                    variant.option2 === selectedOptions.option2 &&
                    variant.option3 === selectedOptions.option3
                  );
              
                  if (matchingVariant) {
                    // console.log('Matching Variant ID:', matchingVariant.id);
                    modifySection.querySelector('.product-add-to-cart a').setAttribute('data-id',matchingVariant.id);
                    // console.log(matchingVariant.featured_image.src);
                    if(matchingVariant.available){
                      modifySection.querySelector('.product-add-to-cart a').removeAttribute('disabled');
                      modifySection.querySelector('.product-add-to-cart a').classList.remove('disabled');
                      var avail_label = modifySection.querySelector('.product-add-to-cart a').getAttribute('data-avail-label');
                      modifySection.querySelector('.product-add-to-cart a').textContent = avail_label;
                    }else{
                      modifySection.querySelector('.product-add-to-cart a').removeAttribute('disabled');
                      modifySection.querySelector('.product-add-to-cart a').classList.remove('disabled');
                      var sold_label = modifySection.querySelector('.product-add-to-cart a').getAttribute('data-sold-label');
                      modifySection.querySelector('.product-add-to-cart a').textContent = sold_label;
                    }

                     if(matchingVariant.featured_image.src){
                      var image_tag = modifySection.querySelector('.product-image img');
                      image_tag.setAttribute('src',matchingVariant.featured_image.src);
                    }
                  } 
            }
          });
        });
      });


        //add to cart event
      document.querySelectorAll('.modify-complete-the-look-section .modify-complete-product').forEach(function(product) {
          product.querySelector('.product-add-to-cart a').addEventListener('click', function() {
            // Your click event logic here
            console.log('Add to cart clicked');
            var var_id = this.getAttribute('data-id');
            var arrPdp = [];
    
           arrPdp.push({id: var_id, quantity: 1});
           let formData = {'items': arrPdp};
            fetch('/cart/add.js', {
              body: JSON.stringify(formData),
              credentials: 'same-origin',
              headers: {
              'Content-Type': 'application/json',
              'X-Requested-With':'xmlhttprequest'
              },
              method: 'POST'
              }).then((response) => {
              return response.json();
              }).then((res) => {
    
              var event = new CustomEvent('apps:product-added-to-cart');
              document.dispatchEvent(event);
    
              const c_btn = document.querySelector('a.header__icon-touch[href="/cart"]');
              c_btn.click();
          });
        });
      });

      //modal opem
            // Select all popup trigger links
        // size popup complete look custom
        const popupTriggers = document.querySelectorAll('.modify-complete-the-look-section [data-popup-trigger]');
        const modal = document.querySelector('[data-modal]');
          const modal_content = document.querySelector('[data-modal] .modal__content ');
        
        // Reusable function to render modal content
        const _renderModalContent = (content) => {
          const clonedContent = content.cloneNode(true);
          modal_content.innerHTML = ""; // Clears previous content in the modal
          modal_content.appendChild(clonedContent);
          wrapIframes(t$2("iframe", modal_content));
          wrapTables(t$2("table", modal_content));
        };
        
        // Function to open the modal
        const _open = () => {
          modal.classList.add('active');
          document.body.setAttribute("data-fluorescent-overlay-open", "true");
          // document.body.style.overflow = 'hidden';
        
          // Uncomment and define focusTrap if required
          // focusTrap.activate();
        
          disableBodyScroll(modal, {
            allowTouchMove: (el) => {
              while (el && el !== document.body) {
                if (el.getAttribute("data-scroll-lock-ignore") !== null) {
                  return true;
                }
                el = el.parentNode;
              }
            },
            reserveScrollBarGap: true
          });
        };
        
        // Loop through each trigger and attach a click event
        popupTriggers.forEach(trigger => {
          trigger.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
        
            const modalContentId = trigger.getAttribute('data-modal-content-id');
            const modalContent = document.querySelector(`#${modalContentId}`);
        
            if (modalContent) {
              _renderModalContent(modalContent);
              _open();
        
              // Dispatch custom event (optional)
              document.dispatchEvent(new CustomEvent('modal:open', {
                detail: { modalContent, narrow: false }
              }));
            }
          });
        });
        
        // Helper functions
        function t$2(n, t) {
          return [].slice.call((t || document).querySelectorAll(n));
        }
        
        function wrapIframes(elements = []) {
          elements.forEach(el => {
            const wrapper = document.createElement("div");
            wrapper.classList.add("rte__iframe");
            el.parentNode.insertBefore(wrapper, el);
            wrapper.appendChild(el);
            el.src = el.src; // Reload iframe source
          });
        }
        
        function wrapTables(elements = []) {
          elements.forEach(el => {
            const wrapper = document.createElement("div");
            wrapper.classList.add("rte__table-wrapper");
            wrapper.tabIndex = 0;
            el.parentNode.insertBefore(wrapper, el);
            wrapper.appendChild(el);
          });
        }
   
});

/*
window.addEventListener("resize", () => {
  console.log("Resize Widnow")
  setTimeout(function(){document.body.matchHeight({elements: '.product-item__product-title'});},500);
});
*/